export * from './services/maps.service';

export * from './maps.component';




// WEBPACK FOOTER //
// ./src/app/modules/maps/index.ts